import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useSettings } from "../lib/settings";
import { InstagramLogo, WhatsAppLogo } from "./BrandIcons";

const LINKS = [
  { to: "/filo", label: "Filo" },
  { to: "/kurumsal", label: "Kurumsal" },
  { to: "/blog", label: "Blog" },
  { to: "/iletisim", label: "İletişim" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const { instagram, whatsapp } = useSettings();

  return (
    <nav
      data-testid="main-navbar"
      className="fixed top-0 w-full z-50 backdrop-blur-xl bg-[#FAFBF6]/80 border-b border-[#B09060]/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo-link">
          <img
            src="/assets/logo-horizontal.svg"
            alt="VIA PRIME Luxury"
            className="h-9 w-auto"
          />
        </Link>

        <div className="hidden md:flex items-center gap-8 text-xs font-semibold tracking-[0.15em] text-[#6B6B6B] uppercase">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `transition-colors hover:text-[#B09060] ${isActive ? "text-[#8F7648]" : ""}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            {instagram && (
              <a
                href={instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="nav-instagram"
                className="block hover:scale-110 transition-transform"
              >
                <InstagramLogo className="w-7 h-7" />
              </a>
            )}
            {whatsapp && (
              <a
                href={whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                data-testid="nav-whatsapp"
                className="block hover:scale-110 transition-transform"
              >
                <WhatsAppLogo className="w-7 h-7" />
              </a>
            )}
          </div>
          <Link
            to="/iletisim"
            data-testid="nav-quote-cta"
            className="hidden sm:inline-block text-xs font-semibold uppercase tracking-[0.12em] bg-[#B09060] text-[#FAFBF6] px-5 py-2.5 rounded-sm hover:bg-[#8F7648] hover:-translate-y-px transition-all duration-300"
          >
            Teklif Al
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden text-[#404040] p-2"
            onClick={() => setOpen(!open)}
            aria-label="Menü"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden px-6 pb-5 flex flex-col gap-4 text-xs font-semibold tracking-[0.15em] text-[#6B6B6B] uppercase border-t border-[#B09060]/10 pt-4 bg-[#FAFBF6]/95 backdrop-blur-xl"
        >
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="hover:text-[#B09060] transition-colors"
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/iletisim"
            onClick={() => setOpen(false)}
            className="text-[#8F7648] font-bold"
          >
            Teklif Al
          </Link>
        </div>
      )}
    </nav>
  );
}
